// 9fbef606107a605d69c0edbcd8029e5d
import { COUNTRY_SELECTOR_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const CONSTANTS = {
  INIT_CHECKOUT: 'INIT_CHECKOUT',
  INIT_CHECKOUT_SECTION_PAGE: 'INIT_CHECKOUT_SECTION_PAGE',
  CHECKOUT_ROUTING_DONE: 'CHECKOUT_ROUTING_DONE',
  REDIRECT_FROM_EXPRESS: 'REDIRECT_FROM_EXPRESS',
  ROUTING_CONST: {
    siteIds: {
      // the values here are the strings that make up the siteId protion of the sites' urls (i.e., it is the 'us' in the path ( /us/favorites)
      us: 'us',
      ca: 'ca',
    },
  },
  EMAIL_REGISTRATION_TYPE_CONSTANT: '10',
  REVIEW_FORM_NAME: 'expressReviewPage',
  CHECKOUT: 'checkout',
  PAY_WITH: 'pay',
  PAYPAL_REDIRECT_PARAM: 'isPaypalPostBack',
  PAYMENT_METHOD_AFTERPAY: 'afterpay',
  PAYMENT_METHOD_VENMO: 'venmo',
  PAYMENT_METHOD_PAYPAL: 'payPal',
  PAYMENT_METHOD_APPLE: 'apple',
  PAYMENT_METHOD_APPLE_PAY: 'applepay',
  PAYMENT_TYPE_APPLE: 'applePay',
  APPLEPAY_LABEL: 'APPLE PAY',
  INTERNATIONAL_CHECKOUT: 'international-checkout',
  INTERNATIONAL_CHECKOUT_PAYPAL_CONFIRMATION: 'international-checkout-paypal-confirmation',
  CREDIT_CARD_CVV_INFO_LABEL: 'cvv_info',
  PAYMENT_METHOD_CREDIT_CARD: 'creditCard',
  GIFT_CERTIFICATE: 'GIFT_CERTIFICATE',
  SET_SMS_UPDATES_CHECK: 'SET_SMS_UPDATES_CHECK',
  GET_TRANS_SMS_SUBSCRIPTION_STATE: 'GET_TRANS_SMS_SUBSCRIPTION_STATE',
  CREDIT_CARD: 'CREDIT_CARD',
  ADS_PLACE_CARD: 'ADSPlaceCard',
  PAY_PAL: 'PAYPAL',
  VENMO: 'VENMO',
  ADDREESS_TYPE: {
    SHIPPING: 'Shipping',
    BILLING: 'Billing',
    SHIPPINGANDBILLING: 'ShippingAndBilling',
    MAILING: 'Mailing',
  },
  DEFAULT_LANGUAGE: 'en',
  REVIEW_ORDER_STATUS: 'V',
  ECOM: 'ECOM',
  NOT_AVAILABLE: '[NOT_AVAILABLE]',
  TRACKING_LINK_PREFIX_CONSTANT: '/shop/TCPOrderLookUp',
  SHIPMENT_TYPE_ID: 1,
  FOR_SEARCH: 1,
  COUPON_SCENARIO_CODE: '1006',
  COUPON_CUSTOMER_LOOKUP_TYPE: '1003',
  BAGPAGE: 'bag',
  HOME: 'home',
  LOGIN: 'login',
  REGISTER: 'register',
  REGISTER_CHECKOUT: 'register-checkout',
  LOGIN_CHECKOUT: 'login-checkout',
  FREE_SHIPPING_URL: '/content/free-shipping',
  US_LOCATION_ID: '0180',
  CA_LOCATION_ID: '3180',
  SINGLE_PAGE_CHECKOUT_PAGE: 'SinglePageCheckoutPage',
  CHECKOUT_STAGES: {
    PICKUP: 'pickup',
    CONTACT_INFO: 'contactinfo',
    SHIPPING: 'shipping',
    BILLING: 'billing',
    REVIEW: 'review',
    CONFIRMATION: 'confirmation',
    STAGES_ARRAY: ['shipping', 'pickup', 'billing', 'review'],
  },

  CHECKOUT_PAGES_NAMES: {
    CHECKOUT: 'checkout',
    PICKUP: 'pickupPage',
    SHIPPING: 'shippingPage',
    BILLING: 'billingPage',
    REVIEW: 'reviewPage',
    CONFIRMATION: 'confirmationPage',
  },
  CHECKOUT_ROOT: 'Checkout',
  PICKUP_DEFAULT_PARAM: 'Pickup',
  SHIPPING_DEFAULT_PARAM: 'Shipping',
  SHIPPING_EDITING_DEFAULT_PARAM: 'ShippingEditing',
  REVIEW_DEFAULT_PARAM: 'Review',
  BILLING_DEFAULT_PARAM: 'Billing',
  CHECKOUT_ROUTES_NAMES: {
    CHECKOUT_PICKUP: 'CheckoutPickup',
    CHECKOUT_SHIPPING: 'CheckoutShipping',
    CHECKOUT_BILLING: 'CheckoutBilling',
    CHECKOUT_REVIEW: 'CheckoutReview',
    CHECKOUT_CONFIRMATION: 'Confirmation',
  },

  PAYMENT_CARD_TYPE: {
    GC: 'GC',
  },

  CHECKOUT_ORDER: {
    ECOM_NO_STORE: 'eComNoStore',
    REVIEW_PRODUCT_SEQUENCE: ['SHIPIT', 'PICKUP'],
    PICKUP_ITEM_ORDER: ['BOPIS', 'BOSS'],
    ORDER_PICKUP_LABEL: 'PICKUP',
    ORDER_SHIPIT_LABEL: 'SHIPIT',
    ORDER_BOPIS_LABEL: 'BOPIS',
    ORDER_BOSS_LABEL: 'BOSS',
  },

  ORDER_ITEM_TYPE: {
    BOSS: 'BOSS',
    BOPIS: 'BOPIS',
    ECOM: 'ECOM',
    PURE_ECOM: 'PURE_ECOM',
  },
  ORDER_ITEM_TYPE_INDEX: {
    BOSS_INDEX: 2,
    BOPIS_INDEX: 1,
    ECOM_INDEX: 0,
  },

  PLACE_CASH: 'PC',
  PLACE_CASH_ERROR: '_PLACE_CASH_ERROR',
  ERR_PROMOTION_NOT_AVAILABLE_AT_THIS_TIME: 'ERR_PROMOTION_NOT_AVAILABLE_AT_THIS_TIME',
  CHECKOUT_FLAGS_SET_LOAD_METHODS: 'CHECKOUT_FLAGS_SET_LOAD_METHODS',
  CHECKOUT_SET_LOAD_SHIPMENT_METHODS: 'CHECKOUT_SET_LOAD_SHIPMENT_METHODS',
  CHECKOUT_ORDER_OPTIONS_SET_SHIPPING: 'CHECKOUT_ORDER_OPTIONS_SET_SHIPPING',
  SUBMIT_SHIPPING_SECTION: 'SUBMIT_SHIPPING_SECTION',
  SUBMIT_REVIEW_SECTION: 'SUBMIT_REVIEW_SECTION',
  CHECKOUT_LOAD_SHIPMENT_METHODS: 'CHECKOUT_LOAD_SHIPMENT_METHODS',
  CHECKOUT_FLAGS_SET_ADDRESS_ERROR: 'CHECKOUT_FLAGS_SET_ADDRESS_ERROR',
  CHECKOUT_VALUES_SET_SMS_UPDATES: 'CHECKOUT_VALUES_SET_SMS_UPDATES',
  CHECKOUT_VALUES_SET_SHIPPING_LOADING: 'CHECKOUT_VALUES_SET_SHIPPING_LOADING',
  ROUTE_TO_PICKUP_PAGE: 'ROUTE_TO_PICKUP_PAGE',
  CHECKOUT_UPDATE_SHIPMENT_METHOD_SELECTION: 'CHECKOUT_UPDATE_SHIPMENT_METHOD_SELECTION',
  UPDATE_SHIPPING_ADDRESS: 'UPDATE_SHIPPING_ADDRESS',
  ADD_NEW_SHIPPING_ADDRESS: 'ADD_NEW_SHIPPING_ADDRESS',
  SET_ON_FILE_ADDRESS_KEY: 'SET_ON_FILE_ADDRESS_KEY',
  SUBMIT_BILLING_SECTION: 'SUBMIT_BILLING_SECTION',
  CHECKOUT_FLAGS_SET_BILLING_VISITED: 'CHECKOUT_FLAGS_SET_BILLING_VISITED',
  SET_GIFTCARD_ERROR: 'SET_GIFTCARD_ERROR',
  RESET_GIFTCARD_ERROR: 'RESET_GIFTCARD_ERROR',
  SET_ORDER_TOTAL: 'SET_ORDER_TOTAL',
  CUSTOM_OOS_ERROR_CODE: 'API_CART_OOS_ITEM',
  CHECKOUT_VAlUES_SET_GIFT_WRAP: 'CHECKOUT_VAlUES_SET_GIFT_WRAP',
  GET_VENMO_CLIENT_TOKEN: 'GET_VENMO_CLIENT_TOKEN',
  GET_VENMO_CLIENT_TOKEN_SUCCESS: 'GET_VENMO_CLIENT_TOKEN_SUCCESS',
  GET_VENMO_CLIENT_TOKEN_ERROR: 'GET_VENMO_CLIENT_TOKEN_ERROR',
  SET_VENMO_PAYMENT_INPROGRESS: 'SET_VENMO_PAYMENT_INPROGRESS',
  SET_APPLE_PAYMENT_INPROGRESS: 'SET_APPLE_PAYMENT_INPROGRESS',
  SET_AFTERPAY_INPROGRESS: 'SET_AFTERPAY_INPROGRESS',
  SET_AFTERPAY_PAYMENT_PROGRESS: 'SET_AFTERPAY_PAYMENT_PROGRESS',
  SET_PAYPAL_PAYMENT_PROGRESS: 'SET_PAYPAL_PAYMENT_PROGRESS',
  SET_AFTERPAY_DRAWER: 'SET_AFTERPAY_DRAWER',
  EXPRESS_AFTERPAY_FLOW: 'EXPRESS_AFTERPAY_FLOW',
  SET_VENMO_DATA: 'SET_VENMO_DATA',
  SET_APPLE_PAY_DATA: 'SET_APPLE_PAY_DATA',
  SET_APPLE_PAY_DATA_APP: 'SET_APPLE_PAY_DATA_APP',
  SET_APPLE_PAY_APP_LOADING: 'SET_APPLE_PAY_APP_LOADING',
  SET_VENMO_PICKUP_MESSAGE_STATE: 'SET_VENMO_PICKUP_MESSAGE_STATE',
  SET_VENMO_SHIPPING_MESSAGE_STATE: 'SET_VENMO_SHIPPING_MESSAGE_STATE',
  SET_VENMO_PAYMENT_OPTION_SAVE: 'SET_VENMO_PAYMENT_OPTION_SAVE',
  SET_VENMO_APP_INSTALLED: 'SET_VENMO_APP_INSTALLED',
  GET_APPLE_CLIENT_TOKEN: 'GET_APPLE_CLIENT_TOKEN',
  GET_APPLE_CLIENT_TOKEN_SUCCESS: 'GET_APPLE_CLIENT_TOKEN_SUCCESS',
  FETCH_PAY_SECURE_SESSION_ID: 'FETCH_PAY_SECURE_SESSION_ID',
  FETCH_PAY_SECURE_SESSION_ID_SUCCESS: 'FETCH_PAY_SECURE_SESSION_ID_SUCCESS',
  FETCH_PAY_SECURE_SESSION_ID_ERROR: 'FETCH_PAY_SECURE_SESSION_ID_ERROR',
  UPDATE_CARD_TOKENIZATION: 'UPDATE_CARD_TOKENIZATION',
  RESET_PAY_SECURE: 'RESET_PAY_SECURE',
  NUMBER_OF_RETRY_FOR_CARD_TOKENIZATION_API: 3,
  CHECKOUT_ORDER_OPTIONS_SET_PAYPAL_PAYMENT: 'CHECKOUT_ORDER_OPTIONS_SET_PAYPAL_PAYMENT',
  CHECKOUT_SUBMIT_VERIFIED_SHIPPING_ADDRESS: 'CHECKOUT_SUBMIT_VERIFIED_SHIPPING_ADDRESS',
  CHECKOUT_FLAGS_SET_BILLING_ADD_GIFT_CARD_SHOW: 'CHECKOUT_FLAGS_SET_BILLING_ADD_GIFT_CARD_SHOW',
  CHECKOUT_FLAGS_SET_BILLING_ADD_GIFT_CARD_HIDE: 'CHECKOUT_FLAGS_SET_BILLING_ADD_GIFT_CARD_HIDE',
  CHECKOUT_FLAGS_SET_PICKUP_UPDATE_FOR_MSG: 'CHECKOUT_FLAGS_SET_PICKUP_UPDATE_FOR_MSG',
  ADD_GIFT_CARD_FAILED: 'ADD_GIFT_CARD_FAILED',
  ADD_GIFT_CARD_SUCCESS: 'ADD_GIFT_CARD_SUCCESS',
  RESET_ADD_GIFT_CARD: 'RESET_ADD_GIFT_CARD',
  RESET_ADD_GIFT_CARD_SUCCESS: 'RESET_ADD_GIFT_CARD_SUCCESS',
  SET_FROM_DATA_IF_NOT_EQUAL: 'SET_FROM_DATA_IF_NOT_EQUAL',
  RESET_CHECKOUT_REDUCER: 'RESET_CHECKOUT_REDUCER',
  INIT_INTL_CHECKOUT: 'INIT_INTL_CHECKOUT',
  SET_IS_RTPS_FLOW: 'SET_IS_RTPS_FLOW',
  SUBMIT_ACCEPT_DECLINE_PLCC_OFFER: 'SUBMIT_ACCEPT_DECLINE_PLCC_OFFER',
  CHECKOUT_VALUES_SET_GIFTWRAP: 'CHECKOUT_VALUES_SET_GIFTWRAP',
  REQUIRE_FORMAT: {
    day: 'ddd',
    month: 'MMM',
    date: 'D',
    year: 'YYYY',
  },
  NA: 'N/A',
  PAYPAL_LOCATE: 'en_US',
  PAYPAL_LABEL: 'paypal',
  UPDATE_CARD_DATA: 'UPDATE_CARD_DATA',
  LOYALITY_OFFERS: 'Loyalty_Offers',
  SET_SERVER_ERROR_CHECKOUT: 'SET_SERVER_ERROR_CHECKOUT',
  SET_CHECKOUT_CLIENT_ERROR: 'SET_CHECKOUT_CLIENT_ERROR',
  COUNTRY_SELECTOR_MODAL_TOGGLE: `${COUNTRY_SELECTOR_ACTION_PATTERN}COUNTRY_SELECTOR_MODAL_TOGGLE`,
  PAGE: 'PAGE',
  PAYPAL_CTA_COLOR: {
    DEFAULT: 'white',
    BLUE: 'blue',
    GOLD: 'gold',
  },
  SHOPPING_BAG: 'shopping bag',
  BROWSE: 'browse',
  CHECKOUT_PAGE: 'checkout',
  CHECKOUT_SHIPPING_PAGE: 'checkout:shipping',
  CHECKOUT_PAYMENT_PAGE: 'checkout:payment',
  LOAD_SHIPMMENT_METHODS: 'LoadEvent',
  CHANGE_SHIPMMENT_METHODS: 'ChangeEvent',
  CALC_VALUE: 'SHIP',
  ADDRESS_STATUS: {
    ADD: 'add',
    NO_ACTION: 'NoAction',
    UPDATE: 'Update',
  },
  SWATCH_TRANSFORMATION: 't_swatch_img',
  SET_CHECKOUT_FOCUS: 'SET_CHECKOUT_FOCUS',
  FETCH_ZIP_CODE_SUGGESTED_ADDRESS: 'FETCH_ZIP_CODE_SUGGESTED_ADDRESS',
  TOGGLE_ZIP_CODE_LOADER: 'TOGGLE_ZIP_CODE_LOADER',
  CALL_PERSIST_EDD: 'CALL_PERSIST_EDD',
  TCP_PROMOTION_COUPON_EXPIRED: '_TCP_PROMOTION_COUPON_EXPIRED',
  ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION: '_ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION',
  SFS_ERROR_TYPES: {
    SHIPPING_ADDRESS: 'shipping_address',
    SHIPPING_METHOD: 'shipping_method',
    GIFT_SERVICES: 'gift_services',
  },
  SET_INIT_CHECKOUT_FINISHED: 'SET_INIT_CHECKOUT_FINISHED',
  EDIT_SHIPPING: 'editShipping',
  SAVE_CARD_CHOICE: 'SAVE_CARD_CHOICE',
  SAVE_CARD_CHOICE_VALUES: {
    SAVE: 'save',
    DO_NOT_SAVE: 'donotsave',
  },
  USER_ACCOUNT_KEY: 'user_account',
  SOMETHING_WENT_WRONG: 'Oh no! Something went wrong… Please try again in a few minutes.',
  SUBMIT_ORDER_TEMP: 'SUBMIT_ORDER_TEMP', // SFCC-TODO: Remove this line after order submission in SPC
  SHIPPING_CODE: {
    UGNR: 'UGNR',
    PMDC: 'PMDC',
    U2AK: 'U2AK',
  },
  TRANSACTION_TYPE: 'PURCHASE',
  GUEST_USER_ID: 'GuestBaseTier',
  CHECKOUT_WITH_AFTERPAY: 'CHECKOUT_WITH_AFTERPAY',
  COUPON_REMOVED: 'COUPON_REMOVED',
  CHECKOUT_BILLING: 'checkoutBilling',
  TCP_PROMOTION_LOYALTY_THRESHOLD_NOT_MET: 'TCP_PROMOTION_LOYALTY_THRESHOLD_NOT_MET',
  TCP_PROMOTION_PLACECASH_THRESHOLD_NOT_MET: 'TCP_PROMOTION_PLACECASH_THRESHOLD_NOT_MET',

  PAYMENT_ACTION: {
    ADD: 'ADD',
    EDIT: 'EDIT',
    SELECT: 'SELECT',
  },
  CHECKOUT_ERROR_MESSAGE: 'SFS shipping not allowed',
  UPDATE_CART_SHIPPING_METHOD: 'UPDATE_CART_SHIPPING_METHOD',
  IS_EXPRESS_CALL_THROUGH_PLCC_FAILURE: 'IS_EXPRESS_CALL_THROUGH_PLCC_FAILURE',
  APPLE_PAY_LOADER: 'APPLE_PAY_LOADER',
  ADD_CREDIT_CARD_RECAPTCHA: 'ADD_CREDIT_CARD_RECAPTCHA',
  IS_SUBMIT_ORDER_ERROR: 'IS_SUBMIT_ORDER_ERROR',
  IS_SUBMIT_ORDER_ERROR_CODE: 'IS_SUBMIT_ORDER_ERROR_CODE',
  UPDATE_SELECTED_METHOD: 'UPDATE_SELECTED_METHOD',
  CHECKOUT_WITH_EXPRESS_AFTERPAY: 'CHECKOUT_WITH_EXPRESS_AFTERPAY',
  SUBMIT_GIFT_SERVICES: 'SUBMIT_GIFT_SERVICES',
  SET_SELECTED_COUNTRY_DROPDOWN: 'SET_SELECTED_COUNTRY_DROPDOWN',
  SET_SELECTED_COUNTRY_DROPDOWN_PICKUP: 'SET_SELECTED_COUNTRY_DROPDOWN_PICKUP',
};

const {
  CHECKOUT_PAGES_NAMES: { CHECKOUT },
  CHECKOUT_STAGES: { SHIPPING, PICKUP, BILLING, REVIEW, CONFIRMATION },
  BAGPAGE,
  HOME,
  LOGIN,
  LOGIN_CHECKOUT,
  INTERNATIONAL_CHECKOUT,
  PAYPAL_REDIRECT_PARAM,
  INTERNATIONAL_CHECKOUT_PAYPAL_CONFIRMATION,
  REGISTER,
} = CONSTANTS;

export const CHECKOUT_ROUTES = {
  bagPage: {
    to: `/${BAGPAGE}`,
    asPath: `/${BAGPAGE}`,
  },
  pickupPage: {
    to: `/${CHECKOUT}?section=${PICKUP}`,
    asPath: `/${CHECKOUT}/${PICKUP}`,
  },
  shippingPage: {
    to: `/${CHECKOUT}?section=${SHIPPING}`,
    asPath: `/${CHECKOUT}/${SHIPPING}`,
  },
  billingPage: {
    to: `/${CHECKOUT}?section=${BILLING}`,
    asPath: `/${CHECKOUT}/${BILLING}`,
  },
  reviewPage: {
    to: `/${CHECKOUT}?section=${REVIEW}`,
    asPath: `/${CHECKOUT}/${REVIEW}`,
  },
  reviewPagePaypal: {
    to: `/${CHECKOUT}?section=${REVIEW}&${[PAYPAL_REDIRECT_PARAM]}=true`,
    asPath: `/${CHECKOUT}/${REVIEW}`,
  },
  internationalCheckout: {
    to: `/${INTERNATIONAL_CHECKOUT}`,
    asPath: `/${INTERNATIONAL_CHECKOUT}`,
  },
  internationalCheckoutPayPalReturn: {
    to: `/${INTERNATIONAL_CHECKOUT_PAYPAL_CONFIRMATION}`,
    asPath: `/${INTERNATIONAL_CHECKOUT_PAYPAL_CONFIRMATION}`,
  },
  confirmationPage: {
    to: `/${CHECKOUT}?section=${CONFIRMATION}`,
    asPath: `/${CHECKOUT}/${CONFIRMATION}`,
  },
  spcConfirmationPage: {
    to: `/${CONFIRMATION}`,
    asPath: `/${CONFIRMATION}`,
  },
  singlePageCheckoutPage: {
    to: `/${CHECKOUT}`,
    asPath: `/${CHECKOUT}`,
  },
  singlePageCheckoutPagePaypal: {
    to: `/${CHECKOUT}?${[PAYPAL_REDIRECT_PARAM]}=true`,
    asPath: `/${CHECKOUT}`,
  },
  home: {
    to: `/${HOME}`,
    asPath: `/${HOME}`,
  },
  login: {
    to: `/${LOGIN}`,
    asPath: `/${LOGIN}`,
  },
  register: {
    to: `/${REGISTER}`,
    asPath: `/${REGISTER}`,
  },
  loginCheckout: {
    to: `/${LOGIN_CHECKOUT}`,
    asPath: `/${LOGIN_CHECKOUT}`,
  },
};

export const APP_TYPE = {
  TCP: 'tcp',
  GYMBOREE: 'gymboree',
  SNJ: 'snj',
  PJP: 'pjp',
};

export const DEEP_LINK_TYPE = {
  GYM: 'gym',
};

export const COMPONENTS = {
  CHECKOUT: 'CHECKOUT',
};

export const SINGLE_PAGE_CHECKOUT_PAGE = 'SinglePageCheckoutPage';

export const RECALCULATE_CACHE = {
  ORDER_DETAILS: 'recalculateOrderDetails',
  FULL_DETAILS: 'orderPointsTimeStamp',
};

export const ORDER_TYPE = {
  PURE_ECOM: 'PURE_ECOM',
  PURE_BOPIS: 'PURE_BOPIS',
  PURE_BOSS: 'PURE_BOSS',
  ECOM_MIX: 'ECOM_MIX',
  BOSS_AND_BOPIS: 'BOSS_AND_BOPIS',
};

export const PAYMENT_METHODS = [
  CONSTANTS.CREDIT_CARD,
  CONSTANTS.ADS_PLACE_CARD,
  CONSTANTS.PAY_PAL,
  CONSTANTS.VENMO,
];

export const DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY = {
  address1: 'DUMMY ADDRESS 1',
  address2: 'DUMMY ADDRESS 2',
  firstName: 'DUMMY_FIRSTNAME',
  lastName: 'DUMMY_LASTNAME',
  phone: '11111111111',
  email: 'dummy@mail.com',
};

export const PAYMENT_METHODS_WITHOUT_CARD_NUMBER = [CONSTANTS.PAY_PAL, CONSTANTS.VENMO];

export default CONSTANTS;
